import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  FormGroup,
  FormInput
} from "shards-react";
import "./loaderStyles.css"; // Import spinner styling
import { Link } from "react-router-dom";

const Register = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null); // State for success message
  const [loading, setLoading] = useState(false); // Loading state
  const history = useHistory();

  const handleRegister = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccessMessage(null); // Reset success message on form submission
    setLoading(true); // Show loader

    try {
      const response = await fetch("https://vaptlabreport.com/shieldapi/Register.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email_id: email,
          password,
          First_name: firstName,
          company_name: companyName
        })
      });

      const result = await response.json();

      if (result.status === "success") {
        setSuccessMessage(result.message); // Set success message from server response
        setTimeout(() => {
          history.push("/login"); // Redirect to login after a short delay
        }, 2000); // Delay the redirect to allow user to see the success message
      } else {
        setError("Registration failed. Please try again.");
      }
    } catch (error) {
      setError("An error occurred. Please try again later.");
    } finally {
      setLoading(false); // Hide loader after response
    }
  };

  return (
    <Container fluid className="main-content-container d-flex align-items-center justify-content-center vh-100">
      <Row className="w-100 justify-content-center" style={{ marginTop: "-20vh" }}>
        <Col lg="4" md="6" className="auth-form mx-auto">
          <Card className="shadow-lg">
            <CardBody>
              <img
                className="auth-form__logo d-table mx-auto mb-3"
                src={require("../images/logo.png")}
                alt="VAPTlabs"
              />

              <h5 className="auth-form__title text-center mb-4">
                Register for a New Account
              </h5>

              {error && <p className="text-danger text-center">{error}</p>}
              {successMessage && (
                <p className="text-success text-center">{successMessage}</p> // Display success message
              )}

              <Form onSubmit={handleRegister}>
                <Row form>
                  <Col md="6">
                    <FormGroup>
                      <label htmlFor="email">Email Address</label>
                      <FormInput
                        type="email"
                        id="email"
                        placeholder="Enter email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label htmlFor="password">Password</label>
                      <FormInput
                        type="password"
                        id="password"
                        placeholder="Enter password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <Row form>
                <Col md="6">
                    <FormGroup>
                      <label htmlFor="firstName">First Name</label>
                      <FormInput
                        type="text"
                        id="firstName"
                        placeholder="Enter first name"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                        required
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label htmlFor="companyName">Company Name</label>
                      <FormInput
                        type="text"
                        id="companyName"
                        placeholder="Enter company name"
                        value={companyName}
                        onChange={(e) => setCompanyName(e.target.value)}
                        required
                      />
                    </FormGroup>
                  </Col>
                 
                </Row>

                {loading ? (
                  <div className="spinner d-table mx-auto" /> // Show loader in place of button
                ) : (
                  <button
                    className="btn btn-accent d-table mx-auto"
                    type="submit"
                  >
                    Register
                  </button>
                )}
              </Form>
            </CardBody>
            <div className="auth-form__meta d-flex mt-4">
              <Link to="/forgot-password">Forgot your password?</Link>
              <Link to="/login" className="ml-auto">
                Sign In?
              </Link>
            </div>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Register;
